import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBackgroundEditorConfig } from '@/data/landingConfig/landingBackgroundEditorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BackgroundEditor } from './schemaObject';

interface Props {}
const BackgroundEditor: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BackgroundEditor} />
			<LandingTemplate
				data={landingBackgroundEditorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAIBackground()}
			/>
		</>
	);
};

export default BackgroundEditor;
